import React, { useEffect, useState } from 'react';
import { Modal, Table, Badge } from 'react-bootstrap';
import API from '../services/api';
import { formatDay } from '../utils/dates';

const money = (n) => new Intl.NumberFormat('es-DO', { style: 'currency', currency: 'DOP' }).format(n || 0);
const dateStr = (d) => formatDay(d);

const STATUS_VARIANT = { draft: 'secondary', sent: 'primary' };
const STATUS_LABEL = { draft: 'Borrador', sent: 'Enviada' };

const ClientQuotesModal = ({ client, onClose }) => {
  const [quotes, setQuotes] = useState(null);
  const [error, setError] = useState('');

  useEffect(() => {
    API.get('/quotes', { params: { client: client._id } })
      .then(res => setQuotes(res.data.filter(q => q.status === 'draft' || q.status === 'sent')))
      .catch(err => {
        console.error('Error loading client quotes:', err);
        setError('No se pudieron cargar las cotizaciones del cliente.');
      });
  }, [client._id]);

  return (
    <Modal show onHide={onClose} centered size="lg">
      <Modal.Header closeButton>
        <Modal.Title>Cotizaciones pendientes — {client.name}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {error && <div className="alert alert-danger">{error}</div>}
        {!quotes && !error && <div className="text-muted">Cargando...</div>}
        {quotes && (
          <Table size="sm" hover responsive>
            <thead>
              <tr>
                <th>No.</th><th>Fecha</th><th>Válida hasta</th><th className="text-end">Total</th><th>Estado</th>
              </tr>
            </thead>
            <tbody>
              {quotes.map(q => (
                <tr key={q._id}>
                  <td>{q.number}</td>
                  <td>{dateStr(q.createdAt)}</td>
                  <td>{dateStr(q.validUntil)}</td>
                  <td className="text-end">{money(q.total)}</td>
                  <td><Badge bg={STATUS_VARIANT[q.status]}>{STATUS_LABEL[q.status] || q.status}</Badge></td>
                </tr>
              ))}
              {quotes.length === 0 && (
                <tr><td colSpan={5} className="text-muted text-center">Sin cotizaciones pendientes.</td></tr>
              )}
            </tbody>
          </Table>
        )}
      </Modal.Body>
    </Modal>
  );
};

export default ClientQuotesModal;
